// @ts-nocheck
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, PropsWithChildren } from "react";
import { css } from "styled-components";

export interface InShellEditNoticeStyles {
    inShellNotice?: TypographyPresentationProps;
}

export const inShellEditNoticeStyles: InShellEditNoticeStyles = {
    inShellNotice: {
        forwardAs: "p",
        css: css`
            padding: ${pxToRem(5)};
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("tertiary.contrast")};
            background-color: ${getColor("tertiary.dark")};
        `,
    },
};

const styles = inShellEditNoticeStyles;

const InShellEditNotice: FC<PropsWithChildren<{}>> = ({ children }) => {
    const { isEditing } = useShellContext();

    return isEditing ? <Typography {...styles.inShellNotice}>{children}</Typography> : null;
};

export default InShellEditNotice;
